import { useTranslation } from 'react-i18next';
import { useEditorStore } from '../../store/editorStore';
import { MobileTimelineCanvas } from './MobileTimelineCanvas';

export function MobileTimelinePanel() {
  const { t } = useTranslation();
  const hasClips = useEditorStore((s) => s.project.tracks.some((tr) => tr.clips.length > 0));

  return (
    <div className="flex flex-col h-full bg-[#0A0A0A] overflow-hidden">
      <div className="flex-1 overflow-y-auto overflow-x-hidden min-h-0">
        {hasClips ? (
          <MobileTimelineCanvas />
        ) : (
          <div className="flex items-center justify-center h-full">
            <p className="text-xs text-[#8E8E93]">{t('editor.dragMediaHere', 'Drag and drop media here')}</p>
          </div>
        )}
      </div>
    </div>
  );
}
